import { Vimeo } from 'react-native-vimeo-iframe'
import { useState } from 'react'
import { getToken } from 'tamagui'

interface IVimeoVideoPlayerProps {
  videoId: string
  onProgress25?: () => void
  onProgress50?: () => void
  onProgress75?: () => void
  onProgress100?: () => void
}

interface IVimeoVideoPlayerData {
  currentTime: number
  duration: number
  percent: number
}

interface IVimeoVideoPlayerCallbacks {
  timeupdate: (data: IVimeoVideoPlayerData) => void
}

export function VimeoVideoPlayer({
  videoId,
  onProgress25,
  onProgress50,
  onProgress75,
  onProgress100,
}: IVimeoVideoPlayerProps) {
  const [progressMarkers] = useState({
    progress25: false,
    progress50: false,
    progress75: false,
    progress100: false,
  })
  const videoBorderRadius = getToken('$border-radius-md')

  const videoCallbacks: IVimeoVideoPlayerCallbacks = {
    timeupdate: (data) => {
      const progress = data.percent

      if (progress >= 25 && !progressMarkers.progress25) {
        progressMarkers.progress25 = true
        onProgress25?.()
      }
      if (progress >= 50 && !progressMarkers.progress50) {
        progressMarkers.progress50 = true
        onProgress50?.()
      }
      if (progress >= 75 && !progressMarkers.progress75) {
        progressMarkers.progress75 = true
        onProgress75?.()
      }
      if (progress >= 100 && !progressMarkers.progress100) {
        progressMarkers.progress100 = true
        onProgress100?.()
      }
    },
  }

  return (
    <Vimeo
      videoId={videoId}
      params={'api=1&autoplay=0'}
      handlers={videoCallbacks}
      style={{
        borderRadius: videoBorderRadius,
        backgroundColor: 'transparent',
      }}
    />
  )
}
